import { render } from "./Playlist.vue?vue&type=template&id=135a5eec"
import script from "./Playlist.vue?vue&type=script&lang=js"
export * from "./Playlist.vue?vue&type=script&lang=js"
script.render = render

export default script